import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { AgGridApi } from '@northfork/ag-grid'
import { OpenLotRow } from '../../models/open-lot-row.model'
import { MarginEffectSpinnerService } from '../../services/margin-effect-spinner.service'
import { SpecLotMatchesService } from '../../services/spec-lot-matches.service'
import { SpecLotModalComponent } from './spec-lot-modal.component'

@Injectable({
  providedIn: 'root',
})
export class SpecLotModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly specLotMatchesService: SpecLotMatchesService,
    private readonly marginEffectSpinnerService: MarginEffectSpinnerService,
    readonly modalPositionService: ModalPositionService,
  ) {}

  async toggleSpecLotModal(
    accountId: number,
    secId: number,
    exitTranId: string,
    exitLegacyOrigId: number,
    agGridApi: AgGridApi,
  ): Promise<void> {
    const compKey = 'spec-lot'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(SpecLotModalComponent, {
      size: 'xl',
      windowClass: uniqueId,
      keyboard: false,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })
    const openLotRows = this.specLotMatchesService.getOpenLotRows(exitTranId)
    const context = this.specLotMatchesService.getContext(exitTranId)

    modalRef.componentInstance.context = await context
    modalRef.componentInstance.openLotRows = await openLotRows
    const startingSpecLotMatchDataMap = new Map(
      (await openLotRows).map(row => [
        row.lotEntryTranId,
        { hasSpecLotMatch: row.hasSpecLotMatch, units: row.units },
      ]),
    )
    modalRef.componentInstance.isLoading = false

    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)

    try {
      const data: OpenLotRow[] = await modalRef.result
      await this.specLotMatchesService.updateSpecLotMatches(
        accountId,
        secId,
        data,
        exitTranId,
        exitLegacyOrigId,
        startingSpecLotMatchDataMap,
      )
      this.setUpdatingRows(agGridApi, accountId, secId)
    } catch {
      //NO-OP user cancelled/closed modal.
    }
  }

  private setUpdatingRows(
    agGridApi: AgGridApi,
    accountId: number,
    secId: number,
  ): void {
    agGridApi.api.forEachNode(rowNode => {
      if (
        rowNode.data.accountId === accountId &&
        rowNode.data.secId === secId &&
        rowNode.data.marginEffect != null
      ) {
        this.marginEffectSpinnerService.addUpdatingRow(rowNode.data.rowId)
      }
    })
  }
}
